import { editorSocket } from '../socket';
import { getBlockNameByType } from 'lib/blocks';
import { MoreOptions } from 'components/common';
import { DropdownButton } from 'components/common/dropdown';

const EditorBlockIsSelectedOptions = ({
  blockId,
  data,
  markedAsNew,
  messages,
  type
}) => {
  const handleSelectAllClick = () => {
    editorSocket.selectBlocksOfType({ blockType: type });
  };

  const handleSelectAllHiddenClick = () => {
    editorSocket.selectBlocksWithVisibility({ visibility: 'hidden' });
  };

  const handleSelectAllMarkedAsNewClick = () => {
    editorSocket.selectBlocksMarkedAsNew();
  };

  const handleSelectAllVisibleClick = () => {
    editorSocket.selectBlocksWithVisibility({ visibility: 'visible' });
  };

  const handleSelectAllUnderHeading = () => {
    editorSocket.selectBlocksUnderHeading({ blockId });
  };

  const textMinWidth = '140px';

  return (
    <MoreOptions
      buttonStyle={{ padding: '5px 0', height: 28, width: 28 }}
      category="lighter"
      styleContentButtons={false}
    >
      <DropdownButton
        icon="check-double"
        onClick={handleSelectAllClick}
        text={
          `${messages.commonSelectAll} ` +
          `${getBlockNameByType({ messages, type })}` +
          `${messages.editorBlockSelectAllTypeBlocks}`
        }
        textMinWidth={textMinWidth}
      />
      {data.visibility === 'hidden' ? (
        <DropdownButton
          icon="eye-slash"
          onClick={handleSelectAllHiddenClick}
          text={messages.editorBlockSelectAllHidden}
          textMinWidth={textMinWidth}
        />
      ) : (
        <DropdownButton
          icon="eye"
          onClick={handleSelectAllVisibleClick}
          text={messages.editorBlockSelectAllVisible}
          textMinWidth={textMinWidth}
        />
      )}
      {markedAsNew ? (
        <DropdownButton
          icon="thumbtack"
          onClick={handleSelectAllMarkedAsNewClick}
          text={messages.editorBlockSelectAllMarkedAsNew}
          textMinWidth={textMinWidth}
        />
      ) : null}
      {type === 'heading' ? (
        <DropdownButton
          icon="level-down-alt"
          onClick={handleSelectAllUnderHeading}
          text={messages.editorBlockSelectAllUnderHeading}
          textMinWidth={textMinWidth}
        />
      ) : null}
    </MoreOptions>
  );
};

export default EditorBlockIsSelectedOptions;
